import { useAuthStore } from '../stores/authStore';
import { usePermStore } from '../stores/permStore';
import { hasPermission, hasAnyPermission, type Permission } from '../utils/permissions';

export function usePermissions() {
  const { user } = useAuthStore();
  usePermStore(s => s.perms); // překreslí komponenty, když správce změní oprávnění
  const role = user?.role;

  return {
    role,
    can:    (permission: Permission) => hasPermission(role, permission),
    canAny: (permissions: Permission[]) => hasAnyPermission(role, permissions),
  };
}
